var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredDomesticwire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7199 15.2676V15.2676C28.2589 15.2676 25.4531 12.4618 25.4531 9.00077V9.00077",
    stroke: "#20242E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7199 15.2676V15.2676C28.2589 15.2676 25.4531 12.4618 25.4531 9.00077V9.00077",
    stroke: "#20242E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7184 15.2668V10C31.7184 9.44772 31.2707 9 30.7184 9H5C4.44772 9 4 9.44772 4 10V26.8004C4 27.3527 4.44771 27.8004 5 27.8004H16.0514L24.4886 27.8004",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7199 15.2676V15.2676C28.2589 15.2676 25.4531 12.4618 25.4531 9.00077V9.00077",
    stroke: "#20242E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2656 9.00077V9.00077C10.2656 12.4618 7.45988 15.2676 3.99882 15.2676V15.2676",
    stroke: "#20242E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2668 27.8008V27.8008C10.2668 24.3397 7.46106 21.534 4 21.534V21.534",
    stroke: "#20242E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.207 14C15.8263 14 14.707 14.8954 14.707 16C14.707 17.1046 15.5404 18 17.207 18C18.8737 18 19.707 18.8954 19.707 20C19.707 21.1046 18.5877 22 17.207 22M17.207 14C18.1324 14 18.9403 14.4022 19.3726 15M17.207 14V13M17.207 22L17.207 23M17.207 22C16.2817 22 15.4738 21.5978 15.0415 21",
    stroke: "#0E5CF4",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7188 26.0758L34.1971 22.5975L31.7188 19.1191",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 22.5979H34.1956",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredDomesticwire);
export default __webpack_public_path__ + "static/media/ic-colored-domesticwire.7dd21b4f05287fced2123e971e89a5dc.svg";
export { ForwardRef as ReactComponent };